var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-image",class:[{ colored: _vm.data.colored }],attrs:{"data-menucolor":_vm.data.colored ? 'white' : 'black'}},[_c('image-animation',[_c('img',{attrs:{"src":_vm.getImageUrl(_vm.data.image, 'cover-desktop')}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }